import React from 'react'
import { connect } from 'react-redux'
import { actionCreators } from '@/store/InChargeOfInstitutions'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import Resx from '@/components/Resx'
import LoadingIndicator from '@/components/LoadingIndicator'
import { localized } from '@/decorators/localized'
import { Button } from '@/components/button'
import context from '@/context'
import { WhiteBox } from '@/components/Layout/Layout.Box'
import { BsrsGrid, NameColumn } from '@/components/BsrsGrid'
import { GridColumn as Column } from '@progress/kendo-react-grid'
import { dialogTypes } from '@/dialogs'
import { inChargeOfInstitutionsGridButtons } from './gridButtons'

const createDto = userId => ({ userId, id: 0, institution: null, responsibilityType: { id: null } })

@localized()
class InChangeOfInstitutionsView extends React.Component {
  editEntity (inChargeOfInstitution) {
    this.props.openDialog({
      dialogType: dialogTypes.editInChargeOfInstitutions,
      primaryButtonText: 'Common.SaveAndClose',
      onAction: (data) => this.props.save(data),
      localize: this.props.localize,
      locale: this.props.locale,
      inChargeOfInstitution,
      userId: this.props.user.id
    })
  }
  render () {
    const { user, localize, deleteEntity, openDialog, saving, locale } = this.props

    return (
      <WhiteBox header='UsersManagement.InChargeOfInstitution'>
        <Button color='primary' className='btn-sm' disabled={saving} onClick={() => this.editEntity(createDto(user.id))} icon='plus'>
          <Resx name='Common.Add' />
        </Button>
        {saving ? <LoadingIndicator />
          : <BsrsGrid
            simpleView
            dataSource={request => context.api.individualInChargeOfInstitutionService.getTableData(user.id, request)}
            lastReloadedAt={this.props.gridKey}>
            <Column field='institutionName' title={localize('Common.Name')} />
            <Column field='institutionLatinName' title={localize('Common.LatinName')} />
            {NameColumn({ locale, nameProp: 'responsibilityTypeName', latinNameProp: 'responsibilityTypeLatinName', title: localize('UsersManagement.ResponsibilityType'), editable: false })}
            <Column cell={inChargeOfInstitutionsGridButtons({ openDialog, deleteEntity, edit: x => this.editEntity(x), localize, locale, user })} width='50px' editable={false} />
          </BsrsGrid>}
      </WhiteBox>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    saving: state.inChargeOfInstitutions.saving,
    gridKey: state.inChargeOfInstitutions.gridKey
  }
}

const mapDispatchToProps = {
  save: actionCreators.save,
  deleteEntity: actionCreators.deleteEntity,
  openDialog: dialogActions.openDialog
}

export default connect(mapStateToProps, mapDispatchToProps)(InChangeOfInstitutionsView)



// WEBPACK FOOTER //
// ./src/internal-app/pages/usersManagement/inChargeOfInstitutionsView.js